export { TabManager } from './tabManager';
export type { TabManagerInterface } from './tabManager.types';
